/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 参数解析模块
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-18 20:46:38
 * @LastEditTime: 2023-08-16 18:03:22
 * @FilePath: /client-h5-v2/src/common-ts/params.ts
 */
import store from '@/store/index'
import { getCookie, getUUID } from '@/common-ts/utils'

export default {
  /**
   * @description: 对话接口请求参数的getter
   * @return {*}
   */
  getDialogChatParams () {
    const params = {
      channel: store.getters['global/channel'],
      language: store.getters['global/language'],
      geo: store.getters['global/geo'],
      queryType: 'greeting',
      queryMessage: '',
      userInfo: store.getters['global/userInfo'],
      scenarioCode: store.getters['global/scenarioCode'] || '',
      domainName: store.getters['global/params'].domainName || '',
      requestId: getUUID(),
      timestamp: Date.parse(String(new Date())),
      timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
      accessInfo: store.getters['global/accessInfo'],
      isDebug: false,
      data: store.getters['global/params'].data || '',
      isEncrypt: true,
      signal: {}
    }

    if (!window.location.href.includes('webview')) {
      // greeting请求使用params时，cookie中如果没有userId，vuex中也不会有userId，因为还没存储到vuex中。
      // 非greeting请求时，理论上在greeting后已经将userId存到cookie中了，并且每一次都会将其userId存入vuex。
      // getDialogChatParams此方法中的params适用于所有对话接口请求时的参数获取，为避免cookie在不同的宿主环境获取不到的情况，所以在cookie其次使用了vuex
      params.userInfo.userId = getCookie('userId') || localStorage.getItem('userId') || store.getters['session/userId'] || ''
    } else {
      // webview 始终指定后端返回的userId
      params.userInfo.userId = store.getters['session/userId'] || ''
    }

    // 如果小乐已经登录，将小乐的登录信息放入accessInfo
    params.accessInfo['loginInfo'] = {}
    if (getCookie('isLogin')) {
      if (window.passport) {
        params.accessInfo['loginInfo'] = window.passport.cookie
      }
      params.accessInfo['loginInfo']['isLogin'] = 'true'
    } else {
      // 根据携带token获取用户信息
      if (store.getters['login/userInfo'].isLogin) {
        params.accessInfo['loginInfo'] = store.getters['login/userInfo']
        params.accessInfo['loginInfo']['isLogin'] = 'true'
      } else {
        params.accessInfo['loginInfo']['isLogin'] = 'false'
      }
    }

    let referrer
    if (document.referrer) {
      if (document.referrer.indexOf('solutions') !== -1) {
        referrer = document.referrer.split('solutions')[1].split('/')[1].split('-')[0]
      }
    }
    params.accessInfo['articleID'] = referrer ? referrer : null
    return params
  },
  /**
   * @description test now 轮循参数封装
   * @return {Object} params 字面量对象
   */
  getTestNowPullMessageParams () {
    return {
      channel: store.getters['global/channel'],
      language: store.getters['global/language'],
      geo: store.getters['global/geo'],
      userId: getCookie('userId') || localStorage.getItem('userId') || store.getters['session/userId'] || '',
      scenarioCode: store.getters['global/scenarioCode'] || '',
      requestId: '',
      timestamp: Date.parse(String(new Date())),
      buttonType: '',
      buttonUsage: '',
      value: '',
      testId: ''
    }
  },
  /**
   * @description test now 超时请求参数封装
   * @param {Object} item
   * @return {Object} dialogParams 字面量对象
   */
  getTestNowTimeoutParams (item:any) {
    // 组装超时queryMessage参数
    const queryMessage = {
      turnId: store.getters['session/turnId'],
      slots: [{result: 'timeout'}],
      buttonType: item.buttonType,
      buttonUsage: item.buttonUsage,
      value: item.content
    }
    // 获取对话参数
    const dialogParams = this.getDialogChatParams()
    // 更改queryMessage和queryType
    dialogParams.queryMessage = JSON.stringify(queryMessage)
    dialogParams.queryType = 'quickResponse'

    return dialogParams
  },
  /**
   * @description 获取 moli portal 的用户信息表单数据参数
   * @return {Object} dialogParams 字面量对象
   */
  getUserInfoFromDataParams () {
    return {
      channel: store.getters['global/channel'],
      language: store.getters['global/language'],
      geo: store.getters['global/geo'],
      userId: getCookie('userId') || localStorage.getItem('userId') || store.getters['session/userId'] || '',
      country: store.getters['global/country'] || '',
      requestId: '',
      timestamp: Date.parse(String(new Date()))
    }
  }
}

